export const avatarWrapperStyles = {
  cursor: 'pointer',
};
